// extracted by mini-css-extract-plugin
export default {"cont":"Sortby_cont__JhTEL","text":"Sortby_text__OaHhB"};